module.exports = __webpack_public_path__ + "static/media/mk.9830033d.svg";